import React, { useEffect, useRef } from 'react';
import './App.scss';
import api from './api/axios';
import { useState } from "react"
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import Login from './Login';
import logo from './regulaid-logo.png';

function App() {

  const location = useLocation();
  const navigate = useNavigate();

  const [errorOccured, setErrorOccured] = useState(false);

  const [authChecked, setAuthChecked] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {

    const checkAuth = async () => {

      const params = new URLSearchParams(location.search);
      const tmpCode = params.get("code");
      
      if (tmpCode) {

        (Array.from((new URLSearchParams(window.location.search)).entries())).forEach(([key]) => params.delete(key));
        navigate({ search: params.toString() }, { replace: true });

        await api.post("/authenticate", { tmp_code: tmpCode });
      }

      // check is authenticated
      const isAuthenticatedResponse = await api.get("/isAuthenticated");

      const isAuthenticated = isAuthenticatedResponse.status === 200;

      setAuthenticated(isAuthenticated);
      setAuthChecked(true);
    };

    const run = async () => {
      try {
        await checkAuth();
      } catch (error) {
        setErrorOccured(true);
      }
    };

    run();

  }, []);

  if (errorOccured) return (
    <div className="center-container">
      <div className="login-container">
        <div style={{display: 'flex', justifyContent: 'center', marginBottom: '20px'}}>
          <img src={logo} alt="Regulaid Logo" className="login-logo" />
        </div>
        
        <h1>
          KI-Campus Admin-Dashboard
        </h1>
        <span style={{fontSize: '14px', color: '#666666', marginBottom: '10px'}}>
          Aktuell werden Wartungsarbeiten durchgeführt.
          <br/>
          <br/>
          Bitte versuchen Sie es später erneut.
        </span>
      </div>
    </div>
  );

  if (!authChecked) return <></>;

  return (
    <Routes>
      {authenticated ? (
        <Route path="*" element={<Dashboard />} />
      ) : (
        <Route path="*" element={<Navigate to="/login" />} />
      )}
      <Route path="/login" element={<Login />} />
    </Routes>
  );
}

export default App;
